import { scripts } from '@ps/bridge/qc/scripts/scripts'
import qc from 'qc'

export interface IMainConfig {
  autoPlayBgm: boolean;
}

/**
 * 获取 ps.MainConfig 脚本，一般 ui root 才有这个脚本
 */
export const getScript = (node: qc.Node): IMainConfig | undefined => {
  const config: IMainConfig | undefined = node.getScript(scripts.mainConfig.name)
  if (config) {
    return config
  }
}
